<template>
    <div class="card-body btm-pad">
        <hr />
        <div class="row">
            <div class="col-md-6 upgrade-title">
                <p>Device Management Package</p>
                <span class="fa fa-database" style="color: orange"></span>
                <span class="fa fa-bolt" style="color: yellow"></span>
            </div>
            <div class="col-md-1"></div>
            <div class="col-md-5">
                <div class="card card-default">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4">
                                Current Package:
                            </div>
                            <div class="col-md-8">
                                <strong>{{saleDefinition.definition.management.devicePackage.description}}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row row-spacing">
             <div class="col-md-6">
                 <div v-if="saleDefinition.definition.management">
                     <div class="form-group">
                         <label>Select a Package</label>
                         <multiselect
                            v-model="selectedDeviceManagementPackageNumber"
                            :options="sortedDeviceMangementPackages"
                            label="description"
                            track-by="deviceManagementPackageNumber"
                            placeholder="Select"
                            open-direction="bottom"
                         ></multiselect>
                     </div>
                 </div>
                 <button class="btn btn-success" @click="confirmPackageChange()">Change Package</button>
             </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            saleNumber: null,
            saleDefinition: {
                definition: {
                    management: {
                        devicePackage: {
                            description: ''
                        }
                    },
                },
                product: {},
                selectableOptions: {
                    devicePackage: []
                },
            },
            selectedDeviceManagementPackageNumber: null
        }
    },
    mounted() {
        this.saleNumber = this.$route.params.saleNumber;
        this.loadSaleDefinition();
    },
    watch: {
        selectedDeviceManagementPackageNumber(pkg) {
            if (!this.saleDefinition?.definition?.management) return;
            this.saleDefinition.definition.management.deviceManagementPackageNumber = pkg ? pkg.deviceManagementPackageNumber : null;
        }
    },
    computed: {
        sortedDeviceMangementPackages() {
            const pkgs = this.saleDefinition?.selectableOptions?.devicePackage;
            if (!Array.isArray(pkgs)) return [];

            return pkgs
            .filter(pkg => !pkg.expired)
            .slice();
        }
    },
    methods: {
        loadSaleDefinition: function() {
            const hostUrl = this.$config.aimsAPI;
            this.$http.get(`${hostUrl}sales/definition/sale/${this.saleNumber}`).then(
                (response) => {
                    this.saleDefinition = response.data;
                },
                (error) => {
                    console.error(error);
                    this.showError("Error loading Sale Definition", error);
                }
            );
        },

        confirmPackageChange: function() {
            this.$swal({
                title: "Are you sure you want to change to a different Package?",
                text: "The billing will change for this client",
                type: "warning",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
            }).then((result) => {
                if (result.value) {
                    this.changePackage();
                }
            });
        },

        changePackage: function() {
            const hostUrl = this.$config.aimsAPI;
            const saleNumber = this.$route.params.saleNumber;
            const deviceManagement = this.saleDefinition.definition.management;
            this.$http.put(`${hostUrl}sales/definition/${saleNumber}/obj/update`, deviceManagement).then(
                (response) => {
                    this.showSuccess("Successfully changed Package");
                    this.loadSaleDefinition();
                },
                (error) => {
                    console.error(error);
                    this.showError("Error Changing Package", error);
                }
            )
        },
    },
    
}
</script>

<style lang="scss" scoped>
.upgrade-title {
  font-size: 22px;
  text-align: center;
  padding: 5px;
}

.btm-pad {
    padding-bottom: 12em;
}
</style>